module.exports = __webpack_public_path__ + "img/PL00241.cddcf932.png";